import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideAppErrorLogging } from '@wahl-shared/app-error-logging';
import { AppComponent } from './app.component';
import { BusinessCardHistoryComponent } from './business-card-history.component';
import { BusinessCardPreviewComponent } from './business-card-preview.component';
import { BusinessCardRendererComponent } from './business-card-renderer.component';
import { IonicValueAccessorDirective } from './ionic-value-accessor.directive';
import { LegalFooterComponent } from './legal-footer.component';
import { LegalPageComponent } from './legal-page.component';
import { MarketingEmailComponent } from './marketing-email.component';
import { NewsletterEditorComponent } from './newsletter-editor.component';
import { QrCodeFormComponent } from './qr-code-form.component';
import { QrHistoryComponent } from './qr-history.component';
import { QrImportComponent } from './qr-import.component';
import { QrPreviewComponent } from './qr-preview.component';
import { SavedQrCodePickerComponent } from './saved-qr-code-picker.component';
import { httpDiagnosticsInterceptor } from './services/http-diagnostics.interceptor';
import { StickerPrinterComponent } from './sticker-printer.component';
import { environment } from '../environments/environment';

@NgModule({
  declarations: [
    AppComponent,
    BusinessCardHistoryComponent,
    BusinessCardPreviewComponent,
    BusinessCardRendererComponent,
    IonicValueAccessorDirective,
    LegalFooterComponent,
    LegalPageComponent,
    MarketingEmailComponent,
    NewsletterEditorComponent,
    QrCodeFormComponent,
    QrHistoryComponent,
    QrImportComponent,
    QrPreviewComponent,
    SavedQrCodePickerComponent,
    StickerPrinterComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    provideHttpClient(withInterceptors([httpDiagnosticsInterceptor])),
    provideAppErrorLogging({
      apiBaseUrl: environment.apiBaseUrl,
      endpoint: 'app_errors',
      tokenKey: 'qrRouterToken',
      source: 'qr-ui',
      app: 'qr-codes'
    })
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
